import React from 'react';

const ArsCardADD = () => {
  return <h1>이거는 추가하는 컴포넌트입니다.</h1>;
};

export default ArsCardADD;
